const labelsPT = {
    "view": {
        "table": {
            "title": "Sua lista de selos",
            "column": {
                "name": "Nome",
                "owner": "Proprietário",
                "company": "Empresa",
                "contract": "Contrato",
                "info": "Informação",
                "status": "Status",
                "action": "Ação"
            },
            "button": {
                "edit": "Editar",
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "label": {
                "approved": "Aprovado",
                "waiting_approval": "Aguardando Aprovação"
            }
        },
        "message": {
            "success": "Selo foi removido!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "notSubscribed": "Você não está inscrito em nenhum plano, portanto só pode adicionar <strong>3 rótulos</strong>. Por favor, <3>assine</3> um plano para ter quantidade ilimitada de rótulos.",
            "subscriptionUpgrade": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para acessar este recurso.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>retome</1> sua assinatura para acessar este recurso.",
            "noAccess": "Você não tem acesso a este módulo, por favor, entre em contato com a equipe de suporte para mais informações."
        },
        "modal": {
            "delete": {
                "header": "Excluir selo {{labelName}}?",
                "body": "Tem certeza de que deseja excluir o selo {{labelName}}? Esta ação não pode ser desfeita."
            }
        }
    },
    "add": {
        "title": "Adicionar Selo",
        "form": {
            "label": {
                "required": "Obrigatório",
                "name": "Nome",
                "subuser": "Sub-Usuário",
                "logo": "Logo",
                "promo_graphic": "Gráfico Promocional",
                "primary_genre": "Gênero Primário",
                "secondary_genre": "Gênero Secundário",
                "year_established": "Ano de Fundação",
                "releases_in_catalog": "Lançamentos no catálogo",
                "soundcloud": "Soundcloud",
                "website": "Website",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "subuser": "Nota: Use este menu suspenso apenas se quiser adicionar um selo para qualquer um de seus Sub-usuários, caso contrário, deixe não selecionado.",
                "logo": "Envie formatos JPG ou PNG, resolução apenas 1000x1000 px",
                "promo_graphic": "Envie formatos JPG ou PNG, resolução apenas 960x150px, máximo 100kb"
            },
            "placeholder": {
                "subuser": "Selecione Sub-usuário..."
            },
            "button": {
                "reset": "Redefinir",
                "submit": "Enviar"
            },
            "message": {
                "success": "Selo foi adicionado!",
                "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
            }
        },
        "modal": {
            "addLabel": {
                "header": "Adicionar Selo {{labelName}}?",
                "body": "Tem certeza de que deseja criar um novo selo? Por favor, certifique-se de inserir um nome de selo exclusivo. Para ter certeza, verifique se o nome já existe em lojas como Beatport e Traxsource. Toda submissão precisa ser aprovada e registrada pela equipe do Music Link. Normalmente aprovamos e registramos novos selos dentro de 48 horas.",
                "button": {
                    "confirm": "Confirmar",
                    "cancel": "Cancelar"
                }
            }
        },
        "message": {
            "success": "Selo foi adicionado!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        }
    },
    "update": {
        "title": "Editar Selo",
        "form": {
            "label": {
                "required": "Obrigatório",
                "name": "Nome",
                "logo": "Logo",
                "promo_graphic": "Gráfico Promocional",
                "primary_genre": "Gênero Primário",
                "secondary_genre": "Gênero Secundário",
                "year_established": "Ano de Fundação",
                "releases_in_catalog": "Lançamentos no catálogo",
                "soundcloud": "Soundcloud",
                "website": "Website",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "logo": "Envie formatos JPG ou PNG, resolução apenas 1000x1000 px",
                "promo_graphic": "Envie formatos JPG ou PNG, resolução apenas 960x150px, máximo 100kb"
            },
            "placeholder": {},
            "button": {
                "submit": "Enviar"
            },
            "message": {
                "success": "Selo foi atualizado!",
                "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
            }
        }
    }
};

export default labelsPT;